import React, { useCallback, useState } from "react";
import { Spinner } from "react-bootstrap";

export interface LoadingIframeProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  loadingMessage?: React.ReactNode;
}

/**
 * Displays a loading message until the iframe is fully loaded.
 */
export const LoadingIframe: React.FC<LoadingIframeProps> = ({
  loadingMessage = (
    <span>
      <Spinner size="sm" /> Loading preview...
    </span>
  ),
  style,
  width = 640,
  height = 480,
  onLoad: onLoadProp,
  ...iframeProps
}) => {
  const [loading, setLoading] = useState(true);

  const onLoad = useCallback(
    (e: React.SyntheticEvent<HTMLIFrameElement>) => {
      setLoading(false);
      if (onLoadProp) onLoadProp(e);
    },
    [onLoadProp],
  );

  return (
    <div style={{ position: "relative", maxWidth: "100%", maxHeight: "100%", width, height }}>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
          }}
        >
          {loadingMessage}
        </div>
      )}
      <iframe
        {...iframeProps}
        width={width}
        height={height}
        style={{ maxWidth: "100%", maxHeight: "100%", ...style, display: loading ? "none" : undefined }}
        onLoad={onLoad}
      />
    </div>
  );
};
